import * as React from 'react';
import propz from 'propz';
import { Component } from 'react';
import { AppUser } from 'Src/views/App/App';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import { History, Location } from 'history';
import { parse } from 'query-string';
import Moment from 'moment';
import { DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { EVENT_NOTIFICATION_MODE, EVENT_STATUS } from 'Src/consts/event';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { CLUB_EVENT_EDIT_MODE } from '../../../../../consts/event';
import { AGE_GROUPS_SORTED } from '../../../../../consts/school';
import { TABS } from 'Src/consts/common';
import { EmptyComponent } from '../../../../../components/EmptyComponent/EmptyComponent';
import { SchoolEventMatchReportSummary } from '../../../../../components/SchoolEventMatchReportSummary/SchoolEventMatchReportSummary';
import { SchoolEventDisciplineSummary } from '../../../../../components/SchoolEventDisciplineSummary/SchoolEventDisciplineSummary';
import { SchoolEventAttendanceSummary } from 'Src/components/SchoolEventAttendance/SchoolEventAttendanceSummary';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { SchoolEventSummary } from 'Src/components/SchoolEventSummary/SchoolEventSummary';
import { Loader } from 'Src/components/Loader/Loader';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { SchoolEventPerformanceSummary } from 'Src/components/SchoolEventPerformanceSummary/SchoolEventPerformanceSummary';
import { SchoolEventDetailsSummary } from 'Src/components/SchoolEventDetailsSummary/SchoolEventDetailsSummary';
import {
  SchoolEventPlayersSummary,
  SchoolEventPlayerSummary,
  SchoolEventTeamSummary
} from 'Src/components/SchoolEventPlayersSummary/SchoolEventPlayersSummary';
import { Button } from 'Src/components/Button/Button';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { SearchMultiSelectFilter } from 'Src/components/SearchMultiSelectFilter/SearchMultiSelectFilter';
import { SchoolEventJobsSummary } from 'Src/components/SchoolEventJobsSummary/SchoolEventJobsSummary';
import { AttendanceLogModal } from 'Src/components/AttendanceLogModal/AttendanceLogModal';
import {applyEventCommunicationCancellationAction, getEventCommunicationCancellationImpact} from 'Src/helpers/service/eventCommunications';
import {
  cancelEvent,
  batchEventAttendance,
  batchEventPerformance,
  getActionDescriptor,
  getAllSchoolEvents,
  getSchoolEventDetails,
  getSchoolEvents,
  getSchoolEventsCount,
  onDeleteJob,
  reasonForCancellation,
  uncancelEvent,
  updateActionDescriptor,
  updateSchoolEventDetails
} from 'Src/helpers/service/admin/schoolEvents';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  getCoachEvent,
  getAgesGroupFormatted,
  getEventGender,
  getEventGeneratedName,
  getEventStartTime,
  getEventStatus,
  getEventSubtype,
  getEventType,
  getEventVenue,
  getEventVenueType,
  getStaffEvent
} from 'Src/helpers/accessor/accessor';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { sortAges } from 'Src/helpers/event/event';
import { getSchoolSports } from 'Src/helpers/service/admin/user';
import { loadHiddenColumns, saveHiddenColumns } from 'Src/helpers/columnVisibility/columnVisibility';
import {
  getSelectOptionForAge,
  getSelectOptionForEventTypes,
  getSelectOptionForEventVenueType,
  getSelectOptionForSport,
  getSelectOptionForTournamentEventGender,
  getSelectOptionForTournamentEventStatus
} from 'Src/helpers/table/select';
import {
  createEventTasks,
  editEventTasks,
  getEventTasks,
  getSchoolEvent,
  updateSchoolEventTeamPlayersBatch
} from 'Src/helpers/service/admin/event';
import { getEventPlayers, getEventTabs, isHousesEvent, isNonTeamSportEvent } from 'Src/helpers/event/event';
import { getEventNameWithLink } from 'Src/helpers/cell/cell';
import { isClubEvent } from '../../../../../helpers/event/event';
import {
  batchEventDiscipline,
  deleteEvent,
  getSchoolEventMatchReport,
  updateGroupSchoolEventDetails,
  updateSchoolEventMatchReport
} from '../../../../../helpers/service/admin/schoolEvents';
import { updateSchoolEventIndividualsBatch } from '../../../../../helpers/service/admin/schoolEventIndividuals';
import { getSelectOptionsForSubTypeEvent } from '../../../../../helpers/table/select';
import { isUserTeacher, isUserCoach } from 'Src/helpers/user/user';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { getEventEndTime } from '../../../../../helpers/accessor/accessor';
import { SchoolForm } from 'Src/models/form';
import {
  SchoolEvent,
  SchoolEventAttendance,
  SchoolEventIndividualData,
  SchoolEventIndividualPerformance,
  SchoolEventTeamDataPlayer
} from 'Src/models/event';
import { Sport } from 'Src/models/sport';
import { SchoolEventJobForm } from './SchoolEventJobForm/SchoolEventJobForm';
import { SchoolEventIndividualDiscipline } from '../../../../../models/event';
import { AggregateClubParticipationReportForm } from '../../Clubs/Clubs/Reports/AggregateClubParticipationReportForm/AggregateClubParticipationReportForm';
import { FixturesScheduleReport } from './FixturesScheduleReport/FixturesScheduleReport';
import { FixtureParticipationByStudentsReport } from './FixtureParticipationByStudentsReport/FixtureParticipationByStudentsReport';
import { FixtureResultsReport } from './FixtureResultsReport/FixtureResultsReport';
import { DateFixturesReport } from './DateFixturesReport/DateFixturesReport';
import { FixtureHistoryReport } from './FixtureHistoryReport/FixtureHistoryReport';
import { FixtureStatisticsForPeriodReport } from './FixtureStatisticsForPeriodReport/FixtureStatisticsForPeriodReport';
import { SchoolEventDetailsForm } from './SchoolEventDetailsForm/SchoolEventDetailsForm';
import './SchoolEventView/SchoolEventView.scss';
import './SchoolEventReports.scss';

const EVENT_COLUMNS_VIEW_KEY = 'sportsFixtures.allEvents';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Event',
    field: 'generatedName',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getEventNameWithLink
  },
  {
    text: 'Start time',
    field: 'startTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getEventStartTime
  },
  {
    text: 'Finish time',
    field: 'endTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getEventEndTime
  },
  {
    text: 'Type',
    field: 'subtype',
    isSort: false,
    type: FILTER_TYPE.SELECT,
    accessor: getEventSubtype
  },
  {
    text: 'Kind',
    field: 'eventType',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventType
  },
  {
    text: 'Status',
    field: 'status',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventStatus
  },
  {
    text: 'Activity',
    field: 'eventSport',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['sport', 'name']
  },
  {
    text: 'Age',
    field: 'eventAges',
    isSort: false,
    type: FILTER_TYPE.CHECKBOX,
    accessor: getAgesGroupFormatted
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: true,
    type: FILTER_TYPE.CHECKBOX,
    accessor: getEventGender
  },
  {
    text: 'Home/Away',
    field: 'venueType',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventVenueType
  },
  {
    text: 'Venue',
    field: 'venue',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventVenue
  },
  {
    text: 'Coach/Leader',
    field: 'coach',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getCoachEvent
  },
  {
    text: 'Staff',
    field: 'staff',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getStaffEvent
  }
];

interface State {
  items: SchoolEvent[];
  currentPage: number;
  selectedItems: SchoolEvent[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filterOptions: any;
  currentTabIndex: number;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  isErrorModalOpen: boolean;
  errorMessage: string;
  isCreateEventModalOpen: boolean;
  isCreateEventJobModalOpen: boolean;
  isDeleteJobModalOpen: boolean;
  isCancelEventModalOpen: boolean;
  isEditEventDetailsModalOpen: boolean;
  isAggregateEventParticipationReportModalOpen: boolean;
  isFixtureParticipationByStudentsReportModalOpen: boolean;
  isFixtureResultsReportModalOpen: boolean;
  isDateFixturesReportModalOpen: boolean;
  isFixtureHistoryReportModalOpen: boolean;
  isFixturesScheduleReportModalOpen: boolean;
  isFixtureStatisticsForPeriodReportModalOpen: boolean;
  isEditPerformance: boolean;
  isEditDiscipline: boolean;
  isEditAttendance: boolean;
  isEditMatchReportActive: boolean;
  forms: SchoolForm[];
  sports: Sport[];
  eventsDetails: any;
  eventTasks: any[];
  isEditPositions: boolean;
  playersForSummary: SchoolEventPlayerSummary[];
  teamsForSummary: SchoolEventTeamSummary[];
  activeTeamIndex: number;
  actionDescriptorIds: any[];
  eventTaskIndex: number;
  individualPerformance: SchoolEventIndividualPerformance[];
  individualDiscipline: SchoolEventIndividualDiscipline[];
  attendancePlayers: SchoolEventAttendance[];
  matchReport: string;
  isDeleteEventModalOpen: boolean;
  isSuccessDeleteEventModalOpen: boolean;
  isEditAllAttendance: boolean;
  cancelReason: string;
  cancellationCommunicationImpact?: {publicChatOpen: boolean; openPrivateCount: number; needsReplyCount: number; protectedCount: number};
  cancellationPublicReadOnly: boolean;
  cancellationResolveAnsweredPrivate: boolean;
  isAttendanceLogModalOpen: boolean;
  isColumnsMenuOpen: boolean;
  hiddenEventColumns: string[];
  isUncancelEventModalOpen: boolean;
  isReportsModalOpen: boolean;
  eventsView: 'CURRENT' | 'ARCHIVE';
  isEventDrawerOpen: boolean;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class SchoolEvents extends Component<Props, State> {
  private eventsListRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filterOptions: undefined,
      isDataFiltered: false,
      currentTabIndex: 0,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      isErrorModalOpen: false,
      isCreateEventModalOpen: false,
      isCreateEventJobModalOpen: false,
      isDeleteJobModalOpen: false,
      isCancelEventModalOpen: false,
      isEditEventDetailsModalOpen: false,
      isAggregateEventParticipationReportModalOpen: false,
      isFixtureParticipationByStudentsReportModalOpen: false,
      isFixtureResultsReportModalOpen: false,
      isDateFixturesReportModalOpen: false,
      isFixtureHistoryReportModalOpen: false,
      isFixturesScheduleReportModalOpen: false,
      isFixtureStatisticsForPeriodReportModalOpen: false,
      isEditPerformance: false,
      isEditDiscipline: false,
      errorMessage: '',
      forms: [],
      sports: [],
      eventsDetails: undefined,
      eventTasks: [],
      isEditPositions: false,
      playersForSummary: [],
      teamsForSummary: [],
      activeTeamIndex: 0,
      actionDescriptorIds: [],
      eventTaskIndex: 0,
      individualPerformance: [],
      individualDiscipline: [],
      isEditAttendance: false,
      attendancePlayers: [],
      matchReport: '',
      isEditMatchReportActive: true,
      isDeleteEventModalOpen: false,
      isSuccessDeleteEventModalOpen: false,
      isEditAllAttendance: true,
      cancelReason: '',
      cancellationPublicReadOnly: true,
      cancellationResolveAnsweredPrivate: false,
      isAttendanceLogModalOpen: false,
      isColumnsMenuOpen: false,
      hiddenEventColumns: loadHiddenColumns(props.user, EVENT_COLUMNS_VIEW_KEY),
      isUncancelEventModalOpen: false,
      isReportsModalOpen: false,
      eventsView: 'CURRENT',
      isEventDrawerOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });
    document.addEventListener('mousedown', this.onColumnsOutsideClick);
    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onColumnsOutsideClick);
  }

  onColumnsOutsideClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (
      target &&
      target.closest &&
      (target.closest('.allEventsPage__columns') ||
        target.closest('.allEventsPage__filters') ||
        target.closest('.allEventsPage__filterButton'))
    ) {
      return;
    }
    if (this.state.isColumnsMenuOpen) this.setState({ isColumnsMenuOpen: false });
    if (this.state.isShowFilter) {
      this.setState({ isShowFilter: false });
      this.setItems();
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems(undefined, nextProps.location.search);
    }
  }

  setAdditionalItems() {
    const { user } = this.props;
    const filter = {
      where: {
        $or: [{ isSchoolEventsAvailable: true }, { isClubEventsAvailable: true }]
      },
      limit: DEFAULT_LIMIT,
      order: 'name ASC',
      skip: DEFAULT_SKIP
    };

    const formsPromise = getAllForms(user);
    const sportsPromise = getSchoolSports(user, filter);

    return BPromise.all([formsPromise, sportsPromise]).then(([forms, sports]) => {
      const filterOptions = this.getFilterOptions(forms, sports);

      this.setState({
        forms: forms,
        sports: sports,
        filterOptions: filterOptions
      });

      return true;
    });
  }

  setItems(pageOverride?: number, locationSearchOverride?: string) {
    const { history, user } = this.props;
    const requestId = ++this.eventsListRequestId;
    const search = parse(typeof locationSearchOverride === 'string' ? locationSearchOverride : history.location.search);
    const page =
      typeof pageOverride === 'number'
        ? pageOverride
        : typeof search.page !== 'undefined'
        ? Number(search.page)
        : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });
    const eventsView = this.state.eventsView;

    if (eventsView === 'ARCHIVE' && !isDataFiltered) {
      this.setState({
        currentPage: FIRST_PAGE,
        isShowFilter: false,
        isDataFiltered: false,
        filters,
        items: [],
        total: 0,
        basePath: history.location.pathname,
        isLoading: false
      });
      return BPromise.resolve(true);
    }

    const today = new Date();
    const academicStartYear = today.getMonth() >= 8 ? today.getFullYear() : today.getFullYear() - 1;
    const academicStart = new Date(Date.UTC(academicStartYear, 8, 1, 0, 0, 0, 0));
    const academicEnd = new Date(Date.UTC(academicStartYear + 1, 7, 31, 23, 59, 59, 999));
    const requestedStartTime = where.startTime || {};
    where.startTime =
      eventsView === 'CURRENT'
        ? { ...requestedStartTime, $gte: academicStart.toISOString(), $lte: academicEnd.toISOString() }
        : { ...requestedStartTime, $lt: academicStart.toISOString() };

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsPromise = getSchoolEvents(user, serverQueryFilter);

    // Counting can be noticeably slower than fetching the first page. Do not
    // keep the table spinner visible while pagination metadata is calculated.
    getSchoolEventsCount(user, where)
      .then(countObj => {
        if (requestId === this.eventsListRequestId) {
          this.setState({ total: countObj.count });
        }
      })
      .catch(() => undefined);

    return BPromise.resolve(getItemsPromise).then(items => {
      if (requestId !== this.eventsListRequestId) return true;

      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  setEventsView = (eventsView: 'CURRENT' | 'ARCHIVE'): void => {
    if (eventsView === this.state.eventsView) return;

    const { history } = this.props;
    const { forms, sports, basePath } = this.state;
    const filters = getFilters2(COLUMNS, {});
    const filterOptions = this.getFilterOptions(forms, sports);

    this.setState(
      {
        eventsView,
        filters,
        filterOptions,
        isDataFiltered: false,
        isShowFilter: false,
        selectedItems: [],
        isSelectAllChecked: false,
        isEventDrawerOpen: false,
        currentPage: FIRST_PAGE,
        total: 0,
        isLoading: true
      },
      () => {
        if (history.location.search) {
          history.push({
            pathname: basePath || history.location.pathname,
            search: ''
          });
        } else {
          this.setItems(FIRST_PAGE);
        }
      }
    );
  };

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection, basePath } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
      currentTabIndex: 0,
      isEventDrawerOpen: false
    });
  };

  onOpenEventClick = (index: number): void => {
    const selectedItem = this.state.items[index];

    if (selectedItem) {
      this.props.history.push(`/events/event?id=${selectedItem.id}`);
    }
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
      isEventDrawerOpen: false
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    getAllSchoolEvents(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isEventDrawerOpen: false,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isEventDrawerOpen: false,
      isShowFilter: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters, basePath } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;
    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?, index?: number, checkBoxIndex?: number): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters, filterOptions } = this.state;
    const currentFilterField = filters[filterField];
    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      switch (filterType) {
        case FILTER_TYPE.MULTISELECT:
          const options = event.target.options;

          const value = [];
          for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
              value.push(options[i].value);
            }
          }
          nextFilters = {
            ...nextFilters,
            [filterField]: value
          };
          break;
        case FILTER_TYPE.CHECKBOX:
          const columns = COLUMNS;
          const currentField = columns[index].field;
          filterOptions[currentField][checkBoxIndex].isChecked = !filterOptions[currentField][checkBoxIndex].isChecked;

          this.setState({
            filterOptions: filterOptions
          });

          const checkBoxValue = [];
          if (typeof filterOptions[filterField] !== 'undefined') {
            for (let i = 0; i < filterOptions[filterField].length; i++) {
              if (filterOptions[filterField][i].isChecked) {
                checkBoxValue.push(filterOptions[filterField][i].value);
              }
            }
          }
          nextFilters = {
            ...nextFilters,
            [filterField]: checkBoxValue
          };
          break;
        default:
          nextFilters = {
            ...nextFilters,
            [filterField]: filterValue
          };
          break;
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName, basePath } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isEventDrawerOpen: false,
      isShowFilter: false,
      isColumnsMenuOpen: false
    });

    const { history } = this.props;
    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    const { forms, sports, basePath } = this.state;
    const filterOptions = this.getFilterOptions(forms, sports);
    const filters = getFilters2(COLUMNS, {});

    this.setState({
      filterOptions: filterOptions,
      filters,
      isDataFiltered: false,
      selectedItems: [],
      isSelectAllChecked: false,
      isEventDrawerOpen: false,
      isShowFilter: false,
      isColumnsMenuOpen: false
    });

    const { history } = this.props;

    history.push({
      pathname: basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    if (isShowFilter) {
      this.setState({ isShowFilter: false }, () => this.setItems());
      return;
    }

    this.setState({
      isShowFilter: true,
      isColumnsMenuOpen: false
    });
  };

  onDrawerMultiFilterChange = (filterField: string, value: any): void => {
    const currentValues = (this.state.filters[filterField] || []).map(String);
    const stringValue = String(value);
    this.setState({
      filters: {
        ...this.state.filters,
        [filterField]: currentValues.includes(stringValue)
          ? currentValues.filter(item => item !== stringValue)
          : [...currentValues, stringValue]
      }
    });
  };

  onDrawerSingleFilterChange = (filterField: string, value: any): void => {
    const stringValue = String(value);
    this.setState({
      filters: {
        ...this.state.filters,
        [filterField]: String(this.state.filters[filterField] || '') === stringValue ? '' : stringValue
      }
    });
  };

  onEventDateRangeChange = (value: any): void => {
    const range = value || { start: null, end: null };
    this.setState({
      filters: {
        ...this.state.filters,
        startTime: {
          from: range.start ? Moment(range.start).format('DD-MM-YYYY') : '',
          to: range.end ? Moment(range.end).format('DD-MM-YYYY') : ''
        }
      }
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  onOpenAttendanceLog = () => {
    this.setState({ isAttendanceLogModalOpen: true });
  };

  onCloseAttendanceLog = () => {
    this.setState({ isAttendanceLogModalOpen: false });
  };

  onSubmitEventJobForm = data => {
    const { user } = this.props;
    const { selectedItems, eventTaskIndex, eventTasks } = this.state;
    const schoolEventId = selectedItems[0].id;
    const schoolEvent = selectedItems[0];
    this.setState({
      isLoading: true,
      isCreateEventJobModalOpen: false
    });

    const { players, ...rest } = data;

    const dataToSubmit = {
      ...rest,
      assignees: players
    };
    if (eventTaskIndex !== -1) {
      const activeTaskId = eventTasks[eventTaskIndex].id;

      editEventTasks(user, schoolEventId, activeTaskId, dataToSubmit)
        .then(res => getEventTasks(user, schoolEventId))
        .then(eventTasks => {
          const eventTab = getEventTabs(schoolEvent);
          const tabIndex = eventTab.indexOf(TABS.JOBS);
          this.setState({
            currentTabIndex: tabIndex,
            eventTasks: eventTasks,
            isCreateEventJobModalOpen: false,
            isLoading: false
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    } else {
      createEventTasks(user, schoolEventId, dataToSubmit)
        .then(task => {
          const tasks = [...eventTasks];
          tasks.push(task);
          this.setState({
            eventTasks: tasks,
            isLoading: false
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isCreateEventJobModalOpen: false,
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    }
  };

  onChangeEventAttendanceComment = (
    field: 'publicComment' | 'internalComment',
    value: string,
    player: SchoolEventIndividualData | SchoolEventTeamDataPlayer
  ): void => {
    const { attendancePlayers } = this.state;

    const attendanceIndex = attendancePlayers.findIndex(a => a.userId === player.userId);

    let nextAttendancePlayers;

    if (attendanceIndex === -1) {
      nextAttendancePlayers = [
        ...attendancePlayers,
        {
          userId: player.userId,
          permissionId: player.permissionId,
          isAttendance: true,
          [field]: value
        }
      ];
    } else {
      nextAttendancePlayers = attendancePlayers.map((a, i) => (i === attendanceIndex ? { ...a, [field]: value } : a));
    }

    this.setState({ attendancePlayers: nextAttendancePlayers });
  };

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId, activeSchool } = user;
    const { selectedItems, forms } = this.state;
    const { ageGroupsNaming } = activeSchool;
    const ageGroup = propz.get(AGE_GROUPS_SORTED, [ageGroupsNaming]);

    const {
      dateTo,
      dateFrom,
      isShowZero,
      isShowNonZero,
      isGroupBySports,
      genders,
      ages: ageItems,
      isShowInterSchool,
      isShowHouses,
      isShowIntraSchool,
      isShowUnclosed,
      isShowTournament,
      isPrintPP,
      isPrintSEN,
      isPrintFSM,
      isPrintEthnicity,
      isCurrentWeek,
      isNextWeek,
      isCurrentMonth,
      isNextMonth,
      isGroupByForms,
      isGroupByYears,
      isGroupByKeyStages,
      eventSource
    } = data;

    let modData;
    let formsUniq;
    let ages: number[];

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AGGREGATE_EVENT_PARTICIPATION_FOR_PERIOD:
        this.setState({ isAggregateEventParticipationReportModalOpen: false, isLoading: true });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            eventSource,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            groupByForms: isGroupByForms,
            groupByYears: isGroupByYears,
            groupByKeyStages: isGroupByKeyStages
          }
        };
        break;
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.FIXTURES_SCHEDULE:
        this.setState({
          isFixturesScheduleReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            showTournament: isShowTournament,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            currentWeek: isCurrentWeek,
            nextWeek: isNextWeek,
            currentMonth: isCurrentMonth,
            nextMonth: isNextMonth
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.FIXTURE_PARTICIPATION_STATISTICS_BY_STUDENTS:
        this.setState({
          isFixtureParticipationByStudentsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            showZero: isShowZero,
            showNonZero: isShowNonZero,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            groupBySports: isGroupBySports,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.FIXTURE_RESULTS:
        this.setState({
          isFixtureResultsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            showInterSchool: isShowInterSchool,
            showHouses: isShowHouses,
            showIntraSchool: isShowIntraSchool,
            showUnclosed: isShowUnclosed,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.DATE_FIXTURES:
        this.setState({
          isDateFixturesReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);

        modData = {
          reportParamsCSV: {
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.FIXTURE_HISTORY:
        this.setState({
          isFixtureHistoryReportModalOpen: false,
          isLoading: true
        });

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            showInterSchool: isShowInterSchool,
            showHouses: isShowHouses,
            showIntraSchool: isShowIntraSchool,
            showTournament: isShowTournament,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.FIXTURE_STATISTICS_FOR_PERIOD:
        this.setState({
          isFixtureStatisticsForPeriodReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            showInterSchool: isShowInterSchool,
            showHouses: isShowHouses,
            showIntraSchool: isShowIntraSchool,
            showTournament: isShowTournament,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const reportType = data.reportType;
          this.setState({
            isLoading: false
          });
          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}`;
          window.open(url);
        } else {
          this.setState({
            isLoading: false,
            errorMessage: 'No read report',
            isErrorModalOpen: true
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  onShowError = (message: string) => {
    this.setState({
      isErrorModalOpen: true,
      errorMessage: message
    });
  };

  renderEventJobForm(): React.ReactNode {
    const { isCreateEventJobModalOpen, eventTasks, eventTaskIndex, selectedItems } = this.state;
    const { user } = this.props;
    const schoolEvent = selectedItems[0];
    const modalText = eventTaskIndex === -1 ? 'Create job' : 'Edit job';
    return (
      <SimpleModal isOpen={isCreateEventJobModalOpen} title={modalText}>
        <SchoolEventJobForm
          user={user}
          schoolEvent={schoolEvent}
          eventTasks={eventTasks}
          eventTaskIndex={eventTaskIndex}
          onCancel={this.onCloseEventJobClick}
          onSubmit={this.onSubmitEventJobForm}
        />
      </SimpleModal>
    );
  }

  renderDeleteJobModal() {
    const { isDeleteJobModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteJobModalOpen}
        title={'Remove Job'}
        body={`Are you sure you want to remove Job ?`}
        buttonText={'Delete'}
        onButtonClick={this.onDeleteJobClick}
        onCloseClick={this.deleteJobModalClose}
      />
    );
  }

  renderReportModalTitle = (title: string, category: string = 'Event report') => (
    <div className="eReportModalTitle">
      <span className="eReportModalTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span className="eReportModalTitle__copy">
        <span className="eReportModalTitle__name">{title}</span>
        <span className="eReportModalTitle__category">{category}</span>
      </span>
    </div>
  );

  renderAggregateEventParticipationReportFormModal() {
    const { user } = this.props;
    const close = () => this.setState({ isAggregateEventParticipationReportModalOpen: false });
    return (
      <SimpleModal
        isOpen={this.state.isAggregateEventParticipationReportModalOpen}
        title={this.renderReportModalTitle('Aggregated event participation', 'Participation')}
        onCloseClick={close}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <AggregateClubParticipationReportForm
          eventReport
          onCloseClick={close}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={user.activeSchoolId}
          school={user.activeSchool}
        />
      </SimpleModal>
    );
  }

  renderFixturesScheduleReportFormModal() {
    const { isFixturesScheduleReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isFixturesScheduleReportModalOpen}
        title={this.renderReportModalTitle('Fixture schedule', 'Fixtures')}
        onCloseClick={this.closeFixturesScheduleReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <FixturesScheduleReport
          onCloseClick={this.closeFixturesScheduleReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderFixtureParticipationByStudentsReportFormModal() {
    const { isFixtureParticipationByStudentsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isFixtureParticipationByStudentsReportModalOpen}
        title={this.renderReportModalTitle('Participation by students', 'Participation')}
        onCloseClick={this.closeFixtureParticipationByStudentsReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <FixtureParticipationByStudentsReport
          onCloseClick={this.closeFixtureParticipationByStudentsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderFixtureResultsReportFormModal() {
    const { isFixtureResultsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isFixtureResultsReportModalOpen}
        title={this.renderReportModalTitle('Fixture results', 'Results')}
        onCloseClick={this.closeFixtureResultsReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <FixtureResultsReport
          onCloseClick={this.closeFixtureResultsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }
  renderDateFixturesReportFormModal() {
    const { isDateFixturesReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isDateFixturesReportModalOpen}
        title={this.renderReportModalTitle('Fixtures for selected date', 'Fixtures')}
        onCloseClick={this.closeDateFixturesReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <DateFixturesReport
          onCloseClick={this.closeDateFixturesReportForm}
          onSubmit={this.onSubmitReportForm}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }
  renderFixtureHistoryReportFormModal() {
    const { isFixtureHistoryReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isFixtureHistoryReportModalOpen}
        title={this.renderReportModalTitle('Year-on-year fixture history', 'History')}
        onCloseClick={this.closeFixtureHistoryReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <FixtureHistoryReport
          onCloseClick={this.closeFixtureHistoryReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }
  renderFixtureStatisticsForPeriodReportFormModal() {
    const { isFixtureStatisticsForPeriodReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isFixtureStatisticsForPeriodReportModalOpen}
        title={this.renderReportModalTitle('Fixture statistics', 'Statistics')}
        onCloseClick={this.closeFixtureStatisticsForPeriodReportForm}
        showFooter={false}
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isBodyBold={false}
      >
        <FixtureStatisticsForPeriodReport
          onCloseClick={this.closeFixtureStatisticsForPeriodReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  onCreateEventClick = (): void => {
    this.props.history.push({
      pathname: `/events/manager`
    });
  };

  onTabClick = (event, index: number) => {
    if (typeof event !== 'undefined') {
      event.preventDefault();
    }

    const { selectedItems, isEditPerformance, isEditAttendance, isEditPositions, isEditDiscipline } = this.state;
    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;
    const { user } = this.props;

    if (isEditPerformance || isEditAttendance || isEditPositions || isEditDiscipline) {
      return;
    }

    const tabs = getEventTabs(schoolEvent);
    const currentTab = tabs[index];

    const individualPerformance = schoolEvent.results.individualPerformance;
    const individualDiscipline = schoolEvent.results.individualDiscipline;
    const attendance = schoolEvent.results.attendance;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    switch (currentTab) {
      case TABS.DETAILS:
        this.setState({
          isLoading: true
        });
        getSchoolEventDetails(user, eventId).then(details => {
          this.setState({
            currentTabIndex: index,
            eventsDetails: details,
            isLoading: false
          });
        });
        break;
      case TABS.JOBS:
        this.setState({
          isLoading: true
        });
        getEventTasks(user, eventId).then(eventTasks => {
          this.setState({
            currentTabIndex: index,
            eventTasks: eventTasks,
            isLoading: false
          });
        });
        break;
      case TABS.PARTICIPANTS:
        const playersForSummary = this.getPlayersForSummary();
        const teamsForSummary = this.getTeamsForSummary();
        this.setState({
          currentTabIndex: index,
          playersForSummary: playersForSummary,
          teamsForSummary: teamsForSummary
        });
        break;
      case isClubEvent(schoolEvent) ? TABS.PROGRESS : TABS.PERFORMANCE:
        this.setState({
          currentTabIndex: index,
          individualPerformance: individualPerformance
        });
        break;
      case TABS.DISCIPLINE: {
        this.setState({
          currentTabIndex: index,
          individualDiscipline: individualDiscipline
        });
        break;
      }
      case TABS.ATTENDANCE:
        this.setState({
          currentTabIndex: index,
          attendancePlayers: attendancePlayers
        });
        break;
      case isClubEvent(schoolEvent) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        this.setState({
          isLoading: true
        });
        getSchoolEventMatchReport(user, eventId).then(matchReport => {
          const content = propz.get(matchReport, ['content'], '');
          this.setState({
            currentTabIndex: index,
            matchReport: content,
            isLoading: false
          });
        });
        break;
      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  cancelEventModalOpen = () => {
    this.setState({
      isCancelEventModalOpen: true,
      cancelReason: '', cancellationCommunicationImpact: undefined, cancellationPublicReadOnly: true, cancellationResolveAnsweredPrivate: false
    });
    if (propz.get(this.props.user, ['activeSchool', 'settings', 'eventComms', 'askOnEventCancellation'], true)) Promise.all(this.state.selectedItems.map(item => getEventCommunicationCancellationImpact(this.props.user, item.id))).then(items => this.setState({cancellationCommunicationImpact: items.reduce((total, item) => ({publicChatOpen: total.publicChatOpen || item.publicChatOpen, openPrivateCount: total.openPrivateCount + item.openPrivateCount, needsReplyCount: total.needsReplyCount + item.needsReplyCount, protectedCount: total.protectedCount + item.protectedCount}), {publicChatOpen: false, openPrivateCount: 0, needsReplyCount: 0, protectedCount: 0})})).catch(() => undefined);
  };

  cancelEventModalClose = () => {
    this.setState({
      isCancelEventModalOpen: false,
      cancelReason: '',
      selectedItems: []
    });
  };

  deleteEventModalOpen = () => {
    this.setState({
      isDeleteEventModalOpen: true
    });
  };

  deleteEventModalClose = (): void => {
    this.setState({
      isDeleteEventModalOpen: false
    });
  };

  uncancelEventModalOpen = (): void => {
    this.setState({ isUncancelEventModalOpen: true });
  };

  uncancelEventModalClose = (): void => {
    this.setState({ isUncancelEventModalOpen: false });
  };

  onUncancelEventsClick = (): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    this.setState({ isLoading: true, isUncancelEventModalOpen: false });
    BPromise.all(selectedItems.map(event => uncancelEvent(user, event.id)))
      .then(() => this.setState({ selectedItems: [], isLoading: false }, () => this.setItems()))
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], 'Unable to restore events');
        this.setState({ isLoading: false, errorMessage: errorText, isErrorModalOpen: true });
      });
  };

  toggleEventColumn = (column: string): void => {
    const hiddenEventColumns = this.state.hiddenEventColumns.includes(column)
      ? this.state.hiddenEventColumns.filter(item => item !== column)
      : [...this.state.hiddenEventColumns, column];
    saveHiddenColumns(this.props.user, EVENT_COLUMNS_VIEW_KEY, hiddenEventColumns);
    this.setState({ hiddenEventColumns });
  };

  resetEventColumns = (): void => {
    saveHiddenColumns(this.props.user, EVENT_COLUMNS_VIEW_KEY, []);
    this.setState({ hiddenEventColumns: [] });
  };

  deleteSuccessEventModalClose = (): void => {
    this.setState({
      isSuccessDeleteEventModalOpen: false
    });
  };

  editEventDetailsModalOpen = () => {
    this.setState({
      isEditEventDetailsModalOpen: true
    });
  };

  editEventDetailsModalClose = () => {
    this.setState({
      isEditEventDetailsModalOpen: false
    });
  };

  openFixturesScheduleReportForm = () => {
    this.setState({
      isFixturesScheduleReportModalOpen: true
    });
  };

  closeFixturesScheduleReportForm = () => {
    this.setState({
      isFixturesScheduleReportModalOpen: false
    });
  };

  openFixtureParticipationByStudentsReportForm = () => {
    this.setState({
      isFixtureParticipationByStudentsReportModalOpen: true
    });
  };

  closeFixtureParticipationByStudentsReportForm = () => {
    this.setState({
      isFixtureParticipationByStudentsReportModalOpen: false
    });
  };

  openFixtureResultsReportForm = () => {
    this.setState({
      isFixtureResultsReportModalOpen: true
    });
  };

  closeFixtureResultsReportForm = () => {
    this.setState({
      isFixtureResultsReportModalOpen: false
    });
  };

  openDateFixturesReportForm = () => {
    this.setState({
      isDateFixturesReportModalOpen: true
    });
  };

  closeDateFixturesReportForm = () => {
    this.setState({
      isDateFixturesReportModalOpen: false
    });
  };

  openFixtureHistoryReportForm = () => {
    this.setState({
      isFixtureHistoryReportModalOpen: true
    });
  };

  closeFixtureHistoryReportForm = () => {
    this.setState({
      isFixtureHistoryReportModalOpen: false
    });
  };

  openFixtureStatisticsForPeriodReportForm = () => {
    this.setState({
      isFixtureStatisticsForPeriodReportModalOpen: true
    });
  };

  closeFixtureStatisticsForPeriodReportForm = () => {
    this.setState({
      isFixtureStatisticsForPeriodReportModalOpen: false
    });
  };

  updateEventDetails = (data, editMode) => {
    const { selectedItems, items } = this.state;
    const schoolEvent = selectedItems[0];
    const eventId = schoolEvent.id;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isEditEventDetailsModalOpen: false
    });

    let details;

    const singleEditMode = editMode === CLUB_EVENT_EDIT_MODE.SINGLE;
    const getEditEventDetailsService = singleEditMode
      ? updateSchoolEventDetails(user, eventId, data)
      : updateGroupSchoolEventDetails(user, eventId, data);

    getEditEventDetailsService
      .then(_details => {
        details = _details;

        return getSchoolEvent(user, eventId);
      })
      .then(event => {
        const eventsNext = items.map(item => {
          return item.id === eventId ? event : item;
        });

        this.setState({
          isLoading: false,
          eventsDetails: details,
          selectedItems: [event],
          items: eventsNext
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderEventDetailsForm(): React.ReactNode {
    const { isEditEventDetailsModalOpen, eventsDetails, selectedItems } = this.state;
    const { user } = this.props;
    const schoolEvent = selectedItems[0];
    const eventId = propz.get(schoolEvent, ['id'], '');
    return (
      <SimpleModal
        customClass="mSchoolEventDetailsFormWidth"
        isOpen={isEditEventDetailsModalOpen}
        title={'Event details'}
      >
        <SchoolEventDetailsForm
          eventId={eventId}
          user={user}
          onSubmit={this.updateEventDetails}
          onCancel={this.editEventDetailsModalClose}
          eventsDetails={eventsDetails}
          event={schoolEvent}
        />
      </SimpleModal>
    );
  }

  onDeleteEventClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isDeleteEventModalOpen: false,
      isLoading: true
    });

    const promises = selectedItems.map(event => {
      return deleteEvent(user, event.id);
    });
    BPromise.all(promises)
      .then(() => {
        this.setState({
          selectedItems: [],
          isSuccessDeleteEventModalOpen: true
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });

    this.setItems();
  };

  onCancelEventClick = () => {
    const { selectedItems, cancelReason } = this.state;
    const { user } = this.props;
    const isEventUpdateNotificationCustomMessageEnabled = propz.get(
      user,
      ['activeSchool', 'isEventUpdateNotificationCustomMessageEnabled'],
      false
    );
    const notificationMode = isEventUpdateNotificationCustomMessageEnabled
      ? EVENT_NOTIFICATION_MODE.MANUAL
      : EVENT_NOTIFICATION_MODE.AUTO;

    this.setState({
      isLoading: true
    });

    let currentActionDescriptorIds = [];
    let updateEvents = [];
    const promises = selectedItems.map(event => {
      return cancelEvent(user, event.id, notificationMode)
        .then(async res => {
          if (this.state.cancellationCommunicationImpact) await applyEventCommunicationCancellationAction(user, event.id, {publicChat: this.state.cancellationPublicReadOnly ? 'READ_ONLY' : 'KEEP', resolveAnsweredPrivate: this.state.cancellationResolveAnsweredPrivate});
          const updateEvent = res.data;
          const actionDescriptorId = propz.get(res, ['headers', 'action-descriptor-id'], '');
          currentActionDescriptorIds.push(actionDescriptorId);
          updateEvents.push(updateEvent);
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);

          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    });

    BPromise.all(promises).then(res => {
      if (isEventUpdateNotificationCustomMessageEnabled) {
        if (cancelReason) {
          const reasonForCancellationPromise = selectedItems.map(event =>
            reasonForCancellation(user, event.id, cancelReason)
          );
          BPromise.all(reasonForCancellationPromise).then(() => {
            this.updateActionDescriptors(currentActionDescriptorIds, cancelReason);
          });
        } else {
          this.updateActionDescriptors(currentActionDescriptorIds);
        }
      } else {
        this.setState(
          {
            selectedItems: [],
            isCancelEventModalOpen: false,
            actionDescriptorIds: []
          },
          () => {
            this.setItems();
          }
        );
      }
    });
  };

  updateActionDescriptors = (actionDescriptorIds, additionalDescription = '') => {
    const { user } = this.props;
    const promises = actionDescriptorIds.map(actionDescriptorId => {
      return getActionDescriptor(user, actionDescriptorId)
        .then(actionDescriptor => {
          const USERS_COUNT_IN_CHUNK = 30;

          const usersFiltered = [...actionDescriptor.affectedUserList];

          let userChunks = [];

          for (let i = 0; i < usersFiltered.length; i += USERS_COUNT_IN_CHUNK) {
            const chunk = usersFiltered.slice(i, i + USERS_COUNT_IN_CHUNK);
            userChunks.push(chunk);
          }

          const userChunksCount = userChunks.length;

          BPromise.all(
            userChunks.map((userChunk, index) => {
              const data = {
                manualConfirmationStatus: index === userChunksCount - 1 ? 'CONFIRMED' : 'AWAITING_CONFIRMATION',
                usersToNotifyList: userChunk,
                additionalDescription: additionalDescription
              };
              return updateActionDescriptor(user, actionDescriptor.id, data);
            })
          ).then(() => {
            this.setState({
              isLoading: false,
              isCancelEventModalOpen: false,
              actionDescriptorIds: [],
              selectedItems: []
            });
            this.setItems();
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    });
  };

  renderCancelEventModal() {
    const { selectedItems, isCancelEventModalOpen, cancelReason } = this.state;
    const { user } = this.props;
    const isEventUpdateNotificationCustomMessageEnabled = propz.get(
      user,
      ['activeSchool', 'isEventUpdateNotificationCustomMessageEnabled'],
      false
    );

    return (
      <SimpleModal
        isOpen={isCancelEventModalOpen}
        title="Cancel events?"
        onCloseClick={this.cancelEventModalClose}
        showFooter={false}
        customClass="eventCancelModal"
        dialogStyle={{ maxWidth: 500 }}
      >
        <div className="eventCancelForm">
          <div className="eventCancelForm__warning">
            <i>!</i>
            <div>
              <strong>
                {selectedItems.length === 1 ? 'Cancel this event' : `Cancel ${selectedItems.length} events`}
              </strong>
              <span>Participants may be notified about this change.</span>
            </div>
          </div>
          <p>
            Are you sure you want to cancel
            {selectedItems.length === 1 ? (
              <>
                {' '}
                Event <b>{getEventGeneratedName(selectedItems[0], { user: user })}</b> (
                {Moment(selectedItems[0].startTime).format('dddd, MMMM Do YYYY, h:mm a')})?
              </>
            ) : (
              <> the following {selectedItems.length} Events:</>
            )}
          </p>
          {selectedItems.length > 1 && (
            <ul>
              {selectedItems.map((event, index) => (
                <li key={index}>
                  <b>{getEventGeneratedName(event, { user: user })} </b>(
                  {Moment(event.startTime).format('dddd, MMMM Do YYYY, h:mm a')}):
                </li>
              ))}
            </ul>
          )}
          {this.state.cancellationCommunicationImpact && (this.state.cancellationCommunicationImpact.publicChatOpen || this.state.cancellationCommunicationImpact.openPrivateCount > 0) && <div className="eventCancelForm__communications">
            <strong>Open event conversations</strong>
            <p>{this.state.cancellationCommunicationImpact.openPrivateCount} open private chat{this.state.cancellationCommunicationImpact.openPrivateCount === 1 ? '' : 's'}{this.state.cancellationCommunicationImpact.needsReplyCount > 0 ? ` · ${this.state.cancellationCommunicationImpact.needsReplyCount} need a staff reply` : ''}.</p>
            {this.state.cancellationCommunicationImpact.protectedCount > 0 && <p className="eventCancelForm__communicationsWarning">{this.state.cancellationCommunicationImpact.protectedCount} conversation{this.state.cancellationCommunicationImpact.protectedCount === 1 ? ' is' : 's are'} protected, reported or awaiting moderation and will remain open.</p>}
            {this.state.cancellationCommunicationImpact.publicChatOpen && <label><input type="checkbox" checked={this.state.cancellationPublicReadOnly} onChange={event => this.setState({cancellationPublicReadOnly: event.target.checked})} /><span>Make public chats staff-announcements-only</span></label>}
            {this.state.cancellationCommunicationImpact.openPrivateCount > 0 && <label><input type="checkbox" checked={this.state.cancellationResolveAnsweredPrivate} onChange={event => this.setState({cancellationResolveAnsweredPrivate: event.target.checked})} /><span>Resolve answered private chats</span></label>}
            <small>Chats needing a reply, reported messages and conversations protected for safeguarding are not resolved automatically.</small>
          </div>}
          {isEventUpdateNotificationCustomMessageEnabled && (
            <>
              <p className="eventCancelForm__hint">
                Add an optional note for team members and parents. Leave it empty to cancel without a reason.
              </p>
              <label htmlFor="cancelReason">
                Reason for cancellation <span>Optional</span>
              </label>
              <textarea
                id="cancelReason"
                value={cancelReason}
                placeholder="Enter cancellation reason"
                onChange={e => this.setState({ cancelReason: e.target.value })}
                className="eventCancelForm__textarea"
                rows={3}
              />
            </>
          )}
          <div className="eventCancelForm__actions">
            <button onClick={this.cancelEventModalClose}>
              {selectedItems.length === 1 ? 'Keep event active' : 'Keep events active'}
            </button>
            <button className="is-danger" onClick={this.onCancelEventClick}>
              Confirm cancellation
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderDeleteEventModal() {
    const { selectedItems, isDeleteEventModalOpen } = this.state;
    const { user } = this.props;
    const eventName = getEventGeneratedName(selectedItems[0], { user: user });

    return (
      <SimpleModal
        isOpen={isDeleteEventModalOpen}
        title="Delete events?"
        onCloseClick={this.deleteEventModalClose}
        showFooter={false}
        customClass="eventConfirmModal"
      >
        <div className="eventConfirm">
          <i className="is-danger">!</i>
          <h3>{selectedItems.length === 1 ? eventName : `${selectedItems.length} events selected`}</h3>
          <p>
            This permanently removes the selected {selectedItems.length === 1 ? 'event' : 'events'} and cannot be
            undone.
          </p>
          <div>
            <button onClick={this.deleteEventModalClose}>Keep events</button>
            <button className="is-danger" onClick={this.onDeleteEventClick}>
              Delete permanently
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderUncancelEventModal() {
    const { selectedItems, isUncancelEventModalOpen } = this.state;
    if (!isUncancelEventModalOpen) return null;
    return (
      <SimpleModal
        isOpen
        title="Restore cancelled events?"
        onCloseClick={this.uncancelEventModalClose}
        showFooter={false}
        customClass="eventConfirmModal"
      >
        <div className="eventConfirm">
          <i>↻</i>
          <h3>
            {selectedItems.length} {selectedItems.length === 1 ? 'event' : 'events'} selected
          </h3>
          <p>The selected events will become active again and return to event management.</p>
          <div>
            <button onClick={this.uncancelEventModalClose}>Keep cancelled</button>
            <button className="is-primary" onClick={this.onUncancelEventsClick}>
              Restore events
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderReportsModal() {
    if (!this.state.isReportsModalOpen) return null;
    const { user } = this.props;
    const isUserTeacherOrCoach = isUserTeacher(user) || isUserCoach(user);
    const reports = [
      !isUserTeacherOrCoach && {
        name: 'Aggregated event participation',
        description: 'Unique students by historical form, year or key stage. Choose club events, sport events or both.',
        formats: 'Excel',
        action: () => this.setState({ isAggregateEventParticipationReportModalOpen: true })
      },
      {
        name: 'Fixture schedule',
        description: 'Create a fixture schedule for a selected period.',
        formats: 'Excel',
        action: this.openFixturesScheduleReportForm
      },
      !isUserTeacherOrCoach && {
        name: 'Participation by students',
        description: 'Review student participation across fixtures.',
        formats: 'Excel',
        action: this.openFixtureParticipationByStudentsReportForm
      },
      {
        name: 'Fixture statistics',
        description: 'Summarise fixture activity for a selected period.',
        formats: 'Excel',
        action: this.openFixtureStatisticsForPeriodReportForm
      },
      {
        name: 'Fixture results',
        description: 'Export results using your chosen parameters.',
        formats: 'Excel',
        action: this.openFixtureResultsReportForm
      },
      {
        name: 'Fixtures for selected date',
        description: 'Create a list of fixtures for one date.',
        formats: 'Excel',
        action: this.openDateFixturesReportForm
      },
      {
        name: 'Year-on-year history',
        description: 'Compare fixture history between academic years.',
        formats: 'Excel',
        action: this.openFixtureHistoryReportForm
      }
    ].filter(Boolean) as Array<{ name: string; description: string; formats: string; action: () => void }>;
    return (
      <SimpleModal
        isOpen
        title="Printed forms & reports"
        onCloseClick={() => this.setState({ isReportsModalOpen: false })}
        showFooter={false}
        customClass="eEventPrintModal"
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">
          Choose a report. You can configure its contents and format on the next step.
        </div>
        <section className="eEventPrintModal__group">
          <h3 className="eEventPrintModal__groupTitle">Event reports</h3>
          <div className="eEventPrintModal__list">
            {reports.map(report => (
              <button
                type="button"
                className="eEventPrintModal__item"
                key={report.name}
                onClick={() => this.setState({ isReportsModalOpen: false }, report.action)}
              >
                <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
                  </svg>
                </span>
                <span className="eEventPrintModal__itemCopy">
                  <span className="eEventPrintModal__itemHeading">
                    <span>{report.name}</span>
                    <span className="eEventPrintModal__format">{report.formats}</span>
                  </span>
                  <span className="eEventPrintModal__itemDescription">{report.description}</span>
                </span>
                <span className="eEventPrintModal__arrow" aria-hidden="true">
                  ›
                </span>
              </button>
            ))}
          </div>
        </section>
      </SimpleModal>
    );
  }

  renderConfirmationDeleteEventModal() {
    const { isSuccessDeleteEventModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isSuccessDeleteEventModalOpen}
        title={'Success'}
        body={`Event has been successfully removed`}
        buttonText={'Ok'}
        onButtonClick={this.deleteSuccessEventModalClose}
      />
    );
  }

  onSavePositionsClick = () => {
    const { playersForSummary, selectedItems, teamsForSummary } = this.state;
    const { user } = this.props;

    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;

    this.setState({
      isLoading: true
    });

    const promise = isNonTeamSportEvent(schoolEvent)
      ? updateSchoolEventIndividualsBatch(user, eventId, {
          add: [],
          remove: [],
          update: playersForSummary.map(player => {
            const { isCaptain, isViceCaptain, isSub, positionId, playerId } = player;
            return {
              isCaptain: isCaptain,
              isViceCaptain: isViceCaptain,
              sub: isSub,
              positionId: positionId !== '' ? positionId : null,
              id: playerId
            };
          })
        })
      : BPromise.all(
          teamsForSummary.map(teamForSummary =>
            updateSchoolEventTeamPlayersBatch(user, eventId, teamForSummary.teamId, {
              add: [],
              remove: [],
              update: playersForSummary
                .filter(player => player.teamId === teamForSummary.teamId)
                .map(player => {
                  const { isCaptain, isViceCaptain, isSub, positionId, playerId } = player;
                  return {
                    isCaptain: isCaptain,
                    isViceCaptain: isViceCaptain,
                    sub: isSub,
                    positionId: positionId !== '' ? positionId : null,
                    id: playerId
                  };
                })
            })
          )
        );

    promise
      .then(res => {
        return getSchoolEvent(user, eventId);
      })
      .then(event => {
        const playersForSummary = this.getPlayersForSummary(event);
        this.setState({
          isLoading: false,
          isEditPositions: false,
          playersForSummary: playersForSummary,
          selectedItems: [event],
          activeTeamIndex: 0
        });
      });
  };

  onEditPositionsClick = () => {
    this.setState({
      isEditPositions: true
    });
  };

  onChangeTeam = event => {
    const { teamsForSummary } = this.state;
    const teamId = event.target.value;
    const currentTeamIndex = teamsForSummary.findIndex(team => team.teamId === teamId);

    this.setState({
      activeTeamIndex: currentTeamIndex
    });
  };

  onChangeIsSubPlayer = (event, playerId: string): void => {
    const isSub = event.target.checked;
    const { playersForSummary } = this.state;
    const playerIndex = playersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    const nextPlayersForSummary = [...playersForSummary];
    nextPlayersForSummary[playerIndex].isSub = isSub;

    this.setState({
      playersForSummary: nextPlayersForSummary
    });
  };

  onChangeIsCaptainPlayer = (event, playerId) => {
    const isCaptain = event.target.checked;
    const { playersForSummary, teamsForSummary, activeTeamIndex } = this.state;
    const playerIndex = playersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    const nextPlayersForSummary = [...playersForSummary];

    if (isCaptain) {
      const teamId = teamsForSummary[activeTeamIndex].teamId;
      // ahah old captain, yohoho
      const oldCaptainIndex = playersForSummary.findIndex(player => player.teamId === teamId && player.isCaptain);

      // kill captain, i'm a captain
      if (oldCaptainIndex !== -1) {
        nextPlayersForSummary[oldCaptainIndex].isCaptain = false;
      }
      nextPlayersForSummary[playerIndex].isViceCaptain = false;
    }

    nextPlayersForSummary[playerIndex].isCaptain = isCaptain;

    this.setState({
      playersForSummary: nextPlayersForSummary
    });
  };

  onChangeIsViceCaptainPlayer = (event, playerId) => {
    const isViceCaptain = event.target.checked;
    const { playersForSummary } = this.state;
    const playerIndex = playersForSummary.findIndex(player => player.playerId === playerId);
    if (playerIndex === -1) return;
    const nextPlayersForSummary = [...playersForSummary];
    nextPlayersForSummary[playerIndex] = {
      ...nextPlayersForSummary[playerIndex],
      isViceCaptain,
      ...(isViceCaptain ? { isCaptain: false } : {})
    };
    this.setState({ playersForSummary: nextPlayersForSummary });
  };

  onChangePositionPlayer = (event, playerId: string): void => {
    const positionValue = event.target.value;

    const { playersForSummary } = this.state;
    const playerIndex = playersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    const nextPlayersForSummary = [...playersForSummary];
    nextPlayersForSummary[playerIndex].positionId = positionValue;

    this.setState({
      playersForSummary: nextPlayersForSummary
    });
  };

  getPlayersForSummary(event?: SchoolEvent): SchoolEventPlayerSummary[] {
    const { selectedItems } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;
    const schoolEvent = typeof event !== 'undefined' ? event : selectedItems[0];

    const schoolPlayers = getEventPlayers(schoolEvent, activeSchoolId);

    return schoolPlayers.map(schoolPlayer => {
      const { userId, permissionId, firstName, lastName, form, id, teamId } = schoolPlayer;
      const isFormExist = typeof form !== 'undefined';
      const formName = isFormExist ? form.name : '';

      const playerFromEvent = schoolEvent.players.find(
        player => player.userId === userId && player.permissionId === permissionId
      );

      const positionId = typeof playerFromEvent !== 'undefined' ? playerFromEvent.positionId : '';
      const isCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isCaptain : false;
      const isViceCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isViceCaptain : false;
      const isSub = typeof playerFromEvent !== 'undefined' ? playerFromEvent.sub : false;

      return {
        name: `${lastName} ${firstName}`,
        playerId: id,
        form: formName,
        positionId: positionId,
        isCaptain: isCaptain,
        isViceCaptain: isViceCaptain,
        isSub: isSub,
        teamId: teamId
      };
    });
  }

  getTeamsForSummary(): SchoolEventTeamSummary[] {
    const { selectedItems } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;
    const [schoolEvent] = selectedItems;

    return schoolEvent.teamsData
      .filter(team => team.schoolId === activeSchoolId)
      .map(team => ({
        teamName: team.name,
        teamId: team.id,
        houseName: isHousesEvent(schoolEvent) ? team.house.name : undefined
      }));
  }

  onEditEventJobClick = (event, index) => {
    event.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: true,
      eventTaskIndex: index
    });
  };

  deleteJobModalOpen = (event, index): void => {
    this.setState({
      isDeleteJobModalOpen: true,
      eventTaskIndex: index
    });
  };

  deleteJobModalClose = (): void => {
    this.setState({
      isDeleteJobModalOpen: false
    });
  };

  onDeleteJobClick = () => {
    const { user } = this.props;
    const { selectedItems, eventTasks, eventTaskIndex } = this.state;
    const schoolEvent = selectedItems[0];
    const eventId = schoolEvent.id;
    const eventTaskId = eventTasks[eventTaskIndex].id;

    this.setState({
      isDeleteJobModalOpen: false,
      isLoading: true
    });

    onDeleteJob(user, eventId, eventTaskId)
      .then(res => getEventTasks(user, eventId))
      .then(eventTasks => {
        const eventTab = getEventTabs(schoolEvent);
        const tabIndex = eventTab.indexOf(TABS.JOBS);
        this.setState({
          currentTabIndex: tabIndex,
          eventTasks: eventTasks,
          isLoading: false
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onAddEventJobClick = event => {
    event.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: true,
      eventTaskIndex: -1
    });
  };

  onCloseEventJobClick = event => {
    event.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: false,
      eventTaskIndex: 0
    });
  };

  onChangeEventPerformanceClick = (value, player, performanceId) => {
    const { individualPerformance } = this.state;

    const performanceIndex = individualPerformance.findIndex(
      performance => performance.performanceId === performanceId && performance.userId === player.userId
    );

    let nextPerformance;

    if (performanceIndex === -1) {
      nextPerformance = [
        ...individualPerformance,
        {
          performanceId: performanceId,
          userId: player.userId,
          teamId: player.teamId,
          value: value,
          permissionId: player.permissionId
        }
      ];
    } else {
      nextPerformance = [...individualPerformance];
      nextPerformance[performanceIndex].value = value;
    }

    this.setState({
      individualPerformance: nextPerformance
    });
  };

  onSaveEventPerformanceClick = () => {
    const { individualPerformance, selectedItems } = this.state;
    const { user } = this.props;
    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;

    this.setState({
      isLoading: true
    });

    const items = individualPerformance.map(({ userId, permissionId, teamId, performanceId, value, description }) => ({
      userId,
      permissionId,
      teamId,
      performanceId,
      value,
      description
    }));

    const savePromise = items.length ? batchEventPerformance(user, eventId, { items }) : Promise.resolve();
    savePromise
      .then(res => {
        return getSchoolEvent(user, eventId);
      })
      .then(event => {
        this.setState({
          isLoading: false,
          isEditPerformance: false,
          individualPerformance: event.results.individualPerformance,
          selectedItems: [event]
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], 'Performance could not be saved.');
        console.error(error);
        this.setState({ isLoading: false, errorMessage: errorText, isErrorModalOpen: true });
      });
  };

  onEditEventPerformanceClick = () => {
    this.setState({
      isEditPerformance: true
    });
  };

  onChangeEventDisciplineClick = (value, player, disciplineId) => {
    const { individualDiscipline } = this.state;

    const disciplineIndex = individualDiscipline.findIndex(
      discipline => discipline.disciplineId === disciplineId && discipline.userId === player.userId
    );

    let nextDiscipline;

    if (disciplineIndex === -1) {
      nextDiscipline = [
        ...individualDiscipline,
        {
          disciplineId: disciplineId,
          userId: player.userId,
          teamId: player.teamId,
          value: Number(value),
          permissionId: player.permissionId
        }
      ];
    } else {
      nextDiscipline = [...individualDiscipline];
      nextDiscipline[disciplineIndex].value = Number(value);
    }

    this.setState({
      individualDiscipline: nextDiscipline
    });
  };

  onEditEventDisciplineClick = () => {
    this.setState({
      isEditDiscipline: true
    });
  };

  onSaveEventDisciplineClick = () => {
    const { individualDiscipline, selectedItems } = this.state;
    const { user } = this.props;
    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;

    this.setState({
      isLoading: true
    });

    const items = individualDiscipline.map(({ userId, permissionId, teamId, disciplineId, value, description }) => ({
      userId,
      permissionId,
      teamId,
      disciplineId,
      value,
      description
    }));

    const savePromise = items.length ? batchEventDiscipline(user, eventId, { items }) : Promise.resolve();
    savePromise
      .then(res => {
        return getSchoolEvent(user, eventId);
      })
      .then(event => {
        this.setState({
          isLoading: false,
          isEditDiscipline: false,
          individualDiscipline: event.results.individualDiscipline,
          selectedItems: [event]
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], 'Discipline could not be saved.');
        console.error(error);
        this.setState({ isLoading: false, errorMessage: errorText, isErrorModalOpen: true });
      });
  };

  onEditEventMatchReportClick = () => {
    this.setState({
      isEditMatchReportActive: false
    });
  };

  onSaveEventMatchReportClick = () => {
    const { user } = this.props;
    const { selectedItems, matchReport } = this.state;
    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;

    this.setState({
      isLoading: true,
      isEditMatchReportActive: true
    });

    const content = {
      content: matchReport
    };

    updateSchoolEventMatchReport(user, eventId, content)
      .then(matchReport => {
        const content = propz.get(matchReport, ['content'], '');

        this.setState({
          isLoading: false,
          matchReport: content
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onChangeMatchReport = matchReport => {
    this.setState({
      matchReport: matchReport
    });
  };

  getInitAttendancePlayers = attendancePlayers => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { selectedItems } = this.state;
    const [schoolEvent] = selectedItems;
    const allTeamPlayers = getEventPlayers(schoolEvent, activeSchoolId);
    const nextAttendancePlayers = allTeamPlayers.map(player => {
      const attendanceIndex = attendancePlayers.findIndex(attendance => attendance.userId === player.userId);
      if (attendanceIndex === -1) {
        return {
          userId: player.userId,
          isAttendance: true,
          permissionId: player.permissionId
        };
      } else {
        const allAttendancePlayers = attendancePlayers.map(attendance => ({ ...attendance }));
        return allAttendancePlayers[attendanceIndex];
      }
    });
    return nextAttendancePlayers;
  };

  onEditEventAttendanceClick = () => {
    const { selectedItems } = this.state;
    const [schoolEvent] = selectedItems;
    const { results } = schoolEvent;
    const { attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    const allAttendancePlayers = this.getInitAttendancePlayers(attendancePlayers);

    const isOneAttendancePresent = allAttendancePlayers.every(player => {
      return propz.get(player, ['isAttendance'], true);
    });

    this.setState({
      attendancePlayers: allAttendancePlayers,
      isEditAllAttendance: isOneAttendancePresent,
      isEditAttendance: true
    });
  };

  onCancelEventAttendanceClick = () => {
    const { selectedItems } = this.state;
    const [schoolEvent] = selectedItems;
    const attendance = schoolEvent.results.attendance;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    this.setState({
      attendancePlayers: attendancePlayers,
      isEditAttendance: false
    });
  };

  onSaveEventAttendanceClick = () => {
    const { attendancePlayers, selectedItems } = this.state;
    const { user } = this.props;
    const [schoolEvent] = selectedItems;
    const eventId = schoolEvent.id;

    this.setState({ isLoading: true });

    const items = attendancePlayers.map(attendance => ({
      userId: attendance.userId,
      permissionId: attendance.permissionId,
      isAttendance: attendance.isAttendance,
      publicComment: attendance.publicComment,
      internalComment: attendance.internalComment
    }));

    batchEventAttendance(user, eventId, { items })
      .then(() => getSchoolEvent(user, eventId))
      .then(event => {
        this.setState({
          isLoading: false,
          isEditAttendance: false,
          attendancePlayers: event.results.attendance,
          selectedItems: [event]
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  getFilterOptions = (forms, sports) => {
    const user = this.props.user;
    const activeSchool = user.activeSchool;
    const ageGroupsNaming = activeSchool.ageGroupsNaming;

    return {
      venueType: getSelectOptionForEventVenueType(),
      eventAges: getSelectOptionForAge(forms, ageGroupsNaming),
      gender: getSelectOptionForTournamentEventGender(),
      status: getSelectOptionForTournamentEventStatus(),
      eventType: getSelectOptionForEventTypes(),
      eventSport: getSelectOptionForSport(sports),
      subtype: getSelectOptionsForSubTypeEvent()
    };
  };

  onChangeEventAllAttendanceClick = (value: boolean): void => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { selectedItems, attendancePlayers } = this.state;
    const [schoolEvent] = selectedItems;
    const allTeamPlayers = getEventPlayers(schoolEvent, activeSchoolId);

    const nextAttendancePlayers = allTeamPlayers.map(player => {
      const attendanceIndex = attendancePlayers.findIndex(attendance => attendance.userId === player.userId);
      if (attendanceIndex === -1) {
        return {
          userId: player.userId,
          isAttendance: value,
          permissionId: player.permissionId
        };
      } else {
        const allAttendancePlayers = attendancePlayers.map(attendance => {
          return {
            ...attendance,
            isAttendance: value
          };
        });
        return allAttendancePlayers[attendanceIndex];
      }
    });
    this.setState({
      isEditAllAttendance: value,
      attendancePlayers: nextAttendancePlayers
    });
  };

  onChangeEventAttendanceClick = (
    value: boolean,
    player: SchoolEventIndividualData | SchoolEventTeamDataPlayer
  ): void => {
    const { attendancePlayers } = this.state;

    const attendanceIndex = attendancePlayers.findIndex(attendance => attendance.userId === player.userId);

    let nextAttendancePlayers;

    if (attendanceIndex === -1) {
      nextAttendancePlayers = [
        ...attendancePlayers,
        {
          userId: player.userId,
          isAttendance: value,
          permissionId: player.permissionId
        }
      ];
    } else {
      nextAttendancePlayers = attendancePlayers.map(attendance => {
        return attendance.userId === player.userId
          ? {
              ...attendance,
              isAttendance: value
            }
          : { ...attendance };
      });
    }

    const isOneAttendancePresent = nextAttendancePlayers.every(player => {
      return propz.get(player, ['isAttendance'], true);
    });

    this.setState({
      isEditAllAttendance: isOneAttendancePresent,
      attendancePlayers: nextAttendancePlayers
    });
  };

  getSummaryTabs(): React.ReactNode {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const {
      selectedItems,
      eventsDetails,
      currentTabIndex,
      sports,
      isEditPositions,
      activeTeamIndex,
      playersForSummary,
      teamsForSummary,
      eventTasks,
      individualPerformance,
      isEditPerformance,
      isEditAttendance,
      attendancePlayers,
      matchReport,
      isEditMatchReportActive,
      isEditAllAttendance,
      individualDiscipline,
      isEditDiscipline,
      isColumnsMenuOpen,
      hiddenEventColumns
    } = this.state;
    const event = selectedItems[0];
    const currentSport = sports.find(sport => sport.id === event.sportId);
    const allTeamPlayers = getEventPlayers(event, activeSchoolId);

    const tabs = getEventTabs(event);
    const currentTab = tabs[currentTabIndex];

    switch (currentTab) {
      case TABS.SUMMARY:
        return <SchoolEventSummary schoolEvent={event} user={user} />;
      case TABS.DETAILS:
        return <SchoolEventDetailsSummary schoolEvent={event} eventsDetails={eventsDetails} user={user} />;
      case TABS.JOBS:
        return (
          <SchoolEventJobsSummary
            eventTasks={eventTasks}
            onEditEventJobClick={this.onEditEventJobClick}
            onDeleteJobClick={this.deleteJobModalOpen}
          />
        );
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        return (
          <SchoolEventPerformanceSummary
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onEditEventPerformanceClick={this.onChangeEventPerformanceClick}
            individualPerformance={individualPerformance}
            isEditPerformance={isEditPerformance}
          />
        );
      case TABS.DISCIPLINE:
        return (
          <SchoolEventDisciplineSummary
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onEditEventDisciplineClick={this.onChangeEventDisciplineClick}
            individualDiscipline={individualDiscipline}
            isEditDiscipline={isEditDiscipline}
          />
        );
      case TABS.ATTENDANCE:
        return (
          <SchoolEventAttendanceSummary
            user={user}
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onChangeEventAttendanceClick={this.onChangeEventAttendanceClick}
            onChangeEventAllAttendanceClick={this.onChangeEventAllAttendanceClick}
            onChangeEventAttendanceComment={this.onChangeEventAttendanceComment}
            attendancePlayers={attendancePlayers}
            isEditAttendance={isEditAttendance}
            isEditAllAttendance={isEditAllAttendance}
          />
        );
      case TABS.PARTICIPANTS:
        return (
          <SchoolEventPlayersSummary
            schoolEvent={event}
            sport={currentSport}
            players={playersForSummary}
            teams={teamsForSummary}
            activeTeamIndex={activeTeamIndex}
            isEditPositions={isEditPositions}
            onChangeTeam={this.onChangeTeam}
            onChangePositionPlayer={this.onChangePositionPlayer}
            onChangeIsCaptainPlayer={this.onChangeIsCaptainPlayer}
            onChangeIsViceCaptainPlayer={this.onChangeIsViceCaptainPlayer}
            onChangeIsSubPlayer={this.onChangeIsSubPlayer}
          />
        );
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        return (
          <SchoolEventMatchReportSummary
            user={this.props.user}
            isEditMatchReportActive={isEditMatchReportActive}
            schoolEvent={event}
            matchReport={matchReport}
            onChangeMatchReport={this.onChangeMatchReport}
          />
        );
      default:
        return <EmptyComponent />;
    }
  }

  renderSummary() {
    const {
      selectedItems,
      currentTabIndex,
      isEditPositions,
      isEditPerformance,
      isEditDiscipline,
      isEditAttendance,
      isEditMatchReportActive
    } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;
    const isOneItemSelected = selectedItems.length === 1;
    const isAdminOrManager = user.activeRole === 'ADMIN' || user.activeRole === 'MANAGER';

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a event above</div>;
    }
    const event = selectedItems[0];
    const players = getEventPlayers(event, activeSchoolId);

    const summaryTabs = this.getSummaryTabs();

    const tabs = getEventTabs(event);
    const currentTab = tabs[currentTabIndex];

    const isShowEditDetailsButton = currentTab === TABS.DETAILS;
    const isShowAddJobButton = currentTab === TABS.JOBS;
    const isShowEditPositionsButton = !isEditPositions && !isClubEvent(event) && currentTab === TABS.PARTICIPANTS;
    const isShowSavePositionsButton = isEditPositions && !isClubEvent(event) && currentTab === TABS.PARTICIPANTS;
    const isPlayersExist = players.length > 0;

    const isTabProgress = currentTab === TABS.PROGRESS;
    const isTabPerformance = currentTab === TABS.PERFORMANCE;
    const isTabProgressOrPerformance = isTabProgress || isTabPerformance;
    const isShowEditPerformanceButton = !isEditPerformance && isTabProgressOrPerformance;
    const isShowSavePerformanceButton = isEditPerformance && isTabProgressOrPerformance;

    const isShowEditDisciplineButton = !isEditDiscipline && currentTab === TABS.DISCIPLINE;
    const isShowSaveDisciplineButton = isEditDiscipline && currentTab === TABS.DISCIPLINE;

    const isShowEditAttendanceButton = !isEditAttendance && currentTab === TABS.ATTENDANCE;
    const isShowSaveAttendanceButton = isEditAttendance && currentTab === TABS.ATTENDANCE;

    const isTabLeaderAndCoach = currentTab === TABS.LEADER_COACH_NOTES;
    const isTabMatchReport = currentTab === TABS.MATCH_REPORT;
    const isTabbLeaderCoachOrMatchReport = isTabLeaderAndCoach || isTabMatchReport;
    const isShowEditMatchReportButton = isEditMatchReportActive && isTabbLeaderCoachOrMatchReport;
    const isShowSaveMatchReportButton = !isEditMatchReportActive && isTabbLeaderCoachOrMatchReport;

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={tabs} currentTabIndex={currentTabIndex}>
        {isShowEditPositionsButton && (
          <Button
            onClick={this.onEditPositionsClick}
            text={'Edit positions'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isPlayersExist}
          />
        )}
        {isShowSavePositionsButton && (
          <Button
            onClick={this.onSavePositionsClick}
            text={'Save positions'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isPlayersExist}
          />
        )}
        {isShowEditDetailsButton && (
          <Button onClick={this.editEventDetailsModalOpen} text={'Edit details'} customClass={'mt-3 mb-3 ml-3'} />
        )}
        {isShowAddJobButton && (
          <Button onClick={this.onAddEventJobClick} text={'Add job'} customClass={'mt-3 mb-3 ml-3'} />
        )}
        {isShowEditPerformanceButton && (
          <Button
            onClick={this.onEditEventPerformanceClick}
            text={isClubEvent(event) ? 'Edit progress' : 'Edit performance'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isPlayersExist}
          />
        )}
        {isShowSavePerformanceButton && (
          <Button
            onClick={this.onSaveEventPerformanceClick}
            text={isClubEvent(event) ? 'Save progress' : 'Save performance'}
            customClass={'mt-3 mb-3 ml-3'}
          />
        )}
        {isShowEditDisciplineButton && (
          <Button
            onClick={this.onEditEventDisciplineClick}
            text={'Edit discipline'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isPlayersExist}
          />
        )}
        {isShowSaveDisciplineButton && (
          <Button
            onClick={this.onSaveEventDisciplineClick}
            text={'Save discipline'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isPlayersExist}
          />
        )}
        {isShowEditAttendanceButton && (
          <>
            <Button
              onClick={this.onEditEventAttendanceClick}
              text={'Edit attendance'}
              customClass={'mt-3 mb-3 ml-3'}
              disabled={!isPlayersExist}
            />
            {isAdminOrManager && (
              <Button
                onClick={this.onOpenAttendanceLog}
                text={'View log'}
                customClass={'mt-3 mb-3 ml-3 btn-secondary'}
              />
            )}
          </>
        )}
        {isShowSaveAttendanceButton && (
          <>
            <Button
              onClick={this.onCancelEventAttendanceClick}
              text={'Cancel'}
              customClass={'mt-3 mb-3 ml-3 btn-secondary'}
            />
            <Button onClick={this.onSaveEventAttendanceClick} text={'Save'} customClass={'mt-3 mb-3 ml-3'} />
          </>
        )}
        {isShowEditMatchReportButton && (
          <Button
            onClick={this.onEditEventMatchReportClick}
            text={isClubEvent(event) ? 'Edit Leader/Coach notes' : 'Edit match report'}
            customClass={'mt-3 mb-3 ml-3'}
            disabled={!isEditMatchReportActive}
          />
        )}
        {isShowSaveMatchReportButton && (
          <Button
            onClick={this.onSaveEventMatchReportClick}
            text={isClubEvent(event) ? 'Save Leader/Coach notes' : 'Save match report'}
            customClass={'mt-3 mb-3 ml-3'}
          />
        )}
        <div data-help-anchor="event-drawer-tab-content">{summaryTabs}</div>
      </GenericSummary>
    );
  }

  renderGrid() {
    const { user } = this.props;
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total,
      filterOptions,
      isEditPerformance,
      isEditAttendance,
      isEditPositions,
      isEditDiscipline,
      isColumnsMenuOpen,
      hiddenEventColumns,
      eventsView,
      isDataFiltered
    } = this.state;

    const isCancelEventActionAvailable = selectedItems.every(
      item =>
        item.status === EVENT_STATUS.ACCEPTED ||
        item.status === EVENT_STATUS.COLLECTING_INVITE_RESPONSE ||
        item.status === EVENT_STATUS.DRAFT ||
        item.status === EVENT_STATUS.INVITES_SENT ||
        item.status === EVENT_STATUS.ON_HOLD ||
        item.status === EVENT_STATUS.SENDING_INVITES
    );

    const isDeleteEventActionAvailable = selectedItems.every(
      item => item.status === EVENT_STATUS.CANCELED || item.status === EVENT_STATUS.REJECTED
    );

    const selectedIds = new Set(selectedItems.map(item => item.id));
    const pageCount = Math.max(1, Math.ceil(total / LIMIT));
    const pageWindowStart = Math.max(1, Math.min(currentPage - 2, pageCount - 4));
    const pageWindowEnd = Math.min(pageCount, pageWindowStart + 4);
    const pageNumbers = Array.from(
      { length: pageWindowEnd - pageWindowStart + 1 },
      (_, index) => pageWindowStart + index
    );
    const hiddenColumns = new Set(hiddenEventColumns);
    const optionalColumns = [
      ['date', 'Date & time'],
      ['sport', 'Sport'],
      ['ages', 'Ages'],
      ['gender', 'Gender'],
      ['venue', 'Venue'],
      ['status', 'Status']
    ];
    const isRestoreEventActionAvailable =
      selectedItems.length > 0 && selectedItems.every(item => item.status === EVENT_STATUS.CANCELED);
    const drawerFilters = [
      { field: 'eventSport', label: 'Sport', options: (filterOptions && filterOptions.eventSport) || [] },
      { field: 'subtype', label: 'Category', options: (filterOptions && filterOptions.subtype) || [] },
      { field: 'eventType', label: 'Event type', options: (filterOptions && filterOptions.eventType) || [] },
      { field: 'status', label: 'Status', options: (filterOptions && filterOptions.status) || [] },
      { field: 'eventAges', label: 'Ages', options: (filterOptions && filterOptions.eventAges) || [] },
      { field: 'gender', label: 'Gender', options: (filterOptions && filterOptions.gender) || [] },
      { field: 'startTime', label: 'Date', options: [] }
    ];
    const activeDrawerFilters = drawerFilters.filter(filter => {
      const value = filters[filter.field];
      return Array.isArray(value) ? value.length > 0 : value && (value.from || value.to);
    });
    const eventDateFilter = filters.startTime || {};
    const eventDateRange = {
      start: eventDateFilter.from ? Moment(eventDateFilter.from, 'DD-MM-YYYY').toDate() : null,
      end: eventDateFilter.to ? Moment(eventDateFilter.to, 'DD-MM-YYYY').toDate() : null
    };
    const archiveNeedsCriteria = eventsView === 'ARCHIVE' && !isDataFiltered;

    return (
      <div className="allEventsPage">
        <header className="allEventsPage__pageHeader">
          <h1>All events</h1>
          <nav className="allEventsPage__viewTabs" role="tablist" aria-label="Event lists">
            <button
              type="button"
              role="tab"
              aria-selected={eventsView === 'CURRENT'}
              className={eventsView === 'CURRENT' ? 'is-active' : ''}
              onClick={() => this.setEventsView('CURRENT')}
            >
              Current {eventsView === 'CURRENT' && <span>{total}</span>}
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={eventsView === 'ARCHIVE'}
              className={eventsView === 'ARCHIVE' ? 'is-active' : ''}
              onClick={() => this.setEventsView('ARCHIVE')}
            >
              Event archive {eventsView === 'ARCHIVE' && isDataFiltered && <span>{total}</span>}
            </button>
          </nav>
          <button type="button" className="allEventsButton allEventsButton--primary" onClick={this.onCreateEventClick}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Create event
          </button>
        </header>
        <section className="allEventsPage__tableShell">
          <div className="allEventsPage__toolbar">
            <button
              type="button"
              className={`allEventsPage__filterButton ${isShowFilter ? 'is-active' : ''}`}
              onClick={this.onTableFilterClick}
              aria-label="Filters"
            >
              <span />
              Filters
              {activeDrawerFilters.length > 0 && <b>{activeDrawerFilters.length}</b>}
            </button>
            <div className="allEventsPage__columns">
              <button
                type="button"
                className="allEventsButton"
                onClick={() => this.setState({ isColumnsMenuOpen: !isColumnsMenuOpen, isShowFilter: false })}
              >
                <span className="allEventsPage__columnsIcon" /> Columns{' '}
                <b>{optionalColumns.filter(([key]) => !hiddenColumns.has(key)).length + 1}</b>
              </button>
              {isColumnsMenuOpen && (
                <div className="allEventsPage__columnsMenu">
                  <header>
                    <span>Show / hide columns</span>
                    <button onClick={this.resetEventColumns}>Reset</button>
                  </header>
                  <label className="is-required">
                    <input type="checkbox" checked={true} disabled={true} readOnly={true} />
                    <span>Event</span>
                    <small>Always shown</small>
                  </label>
                  {optionalColumns.map(([key, label]) => (
                    <label key={key}>
                      <input
                        type="checkbox"
                        checked={!hiddenColumns.has(key)}
                        onChange={() => this.toggleEventColumn(key)}
                      />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
            <button
              type="button"
              className="allEventsButton allEventsPage__reportsButton"
              onClick={() => this.setState({ isReportsModalOpen: true })}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
                <path d="M14 3v6h6M8 13h8M8 17h5" />
              </svg>
              Reports
            </button>
          </div>
          {activeDrawerFilters.length > 0 && (
            <div className="allEventsPage__filterChips">
              {activeDrawerFilters.map(filter => {
                const filterValue = filters[filter.field];
                const labels =
                  filter.field === 'startTime'
                    ? [filterValue.from, filterValue.to].filter(Boolean)
                    : (Array.isArray(filterValue) ? filterValue : [filterValue]).filter(Boolean).map(value => {
                        const option = filter.options.find(item => String(item.value) === String(value));
                        return option ? option.text : value;
                      });
                return (
                  <span key={filter.field}>
                    <b>{filter.label}:</b> {labels.join(', ')}
                    <button
                      type="button"
                      aria-label={`Remove ${filter.label} filter`}
                      onClick={() =>
                        this.setState(
                          {
                            filters: {
                              ...this.state.filters,
                              [filter.field]: filter.field === 'startTime' ? { from: '', to: '' } : filter.field === 'subtype' ? '' : []
                            }
                          },
                          this.onApplyFilterClick
                        )
                      }
                    >
                      ×
                    </button>
                  </span>
                );
              })}
              <button type="button" className="allEventsPage__filterChipsClear" onClick={this.onClearFilterClick}>
                Clear all
              </button>
            </div>
          )}
          {isShowFilter && (
            <div
              className="allEventsPage__filters"
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  this.onApplyFilterClick();
                }
              }}
            >
              <div className="allEventsPage__filtersHeader">
                <div>
                  <strong>Filters</strong>
                </div>
                <button type="button" aria-label="Close filters" onClick={this.onTableFilterClick}>
                  ×
                </button>
              </div>
              <SearchMultiSelectFilter
                label="Sports"
                selected={(filters.eventSport || []).map(String)}
                options={((filterOptions && filterOptions.eventSport) || []).map(option => ({
                  value: String(option.value),
                  label: String(option.text)
                }))}
                onToggle={value => this.onDrawerMultiFilterChange('eventSport', value)}
                placeholder="Search sports…"
                emptyText="No matching sports"
                className="allEventsPage__sportFilter"
              />
              <fieldset className="allEventsPage__filterGroup">
                <legend>Fixture or club</legend>
                <div className="allEventsPage__filterOptions">
                  {((filterOptions && filterOptions.subtype) || []).map(option => {
                    const isSelected = String(filters.subtype || '') === String(option.value);
                    return (
                      <button
                        key={option.value}
                        type="button"
                        className={isSelected ? 'is-selected' : ''}
                        aria-pressed={isSelected}
                        onClick={() => this.onDrawerSingleFilterChange('subtype', option.value)}
                      >
                        {option.text}
                      </button>
                    );
                  })}
                </div>
              </fieldset>
              {[
                { field: 'eventType', label: 'Event type', options: (filterOptions && filterOptions.eventType) || [] },
                { field: 'status', label: 'Status', options: (filterOptions && filterOptions.status) || [] }
              ].map(filter => (
                <fieldset key={filter.field} className="allEventsPage__filterGroup">
                  <legend>{filter.label}</legend>
                  <div className="allEventsPage__filterOptions">
                    {filter.options.map(option => {
                      const isSelected = (filters[filter.field] || []).map(String).includes(String(option.value));
                      return (
                        <button
                          key={option.value}
                          type="button"
                          className={isSelected ? 'is-selected' : ''}
                          aria-pressed={isSelected}
                          onClick={() => this.onDrawerMultiFilterChange(filter.field, option.value)}
                        >
                          {option.text}
                        </button>
                      );
                    })}
                  </div>
                </fieldset>
              ))}
              <fieldset className="allEventsPage__filterGroup">
                <legend>Age groups</legend>
                <div className="allEventsPage__filterOptions">
                  {((filterOptions && filterOptions.eventAges) || []).map(option => {
                    const isSelected = (filters.eventAges || []).map(String).includes(String(option.value));
                    return (
                      <button
                        key={option.value}
                        type="button"
                        className={isSelected ? 'is-selected' : ''}
                        aria-pressed={isSelected}
                        onClick={() => this.onDrawerMultiFilterChange('eventAges', option.value)}
                      >
                        {option.text}
                      </button>
                    );
                  })}
                </div>
              </fieldset>
              <fieldset className="allEventsPage__filterGroup">
                <legend>Gender</legend>
                <div className="allEventsPage__filterOptions">
                  {((filterOptions && filterOptions.gender) || []).map(option => {
                    const isSelected = (filters.gender || []).map(String).includes(String(option.value));
                    return (
                      <button
                        key={option.value}
                        type="button"
                        className={isSelected ? 'is-selected' : ''}
                        aria-pressed={isSelected}
                        onClick={() => this.onDrawerMultiFilterChange('gender', option.value)}
                      >
                        {option.text}
                      </button>
                    );
                  })}
                </div>
              </fieldset>
              <div className="allEventsPage__dateFilter">
                <SitDatePicker
                  label="Date interval"
                  mode="range"
                  value={eventDateRange}
                  onChange={this.onEventDateRangeChange}
                  format="DD-MM-YYYY"
                  placeholder="Select date range"
                  numberOfMonths={2}
                  align="right"
                  centered={true}
                  clearable={true}
                  syncRangeOnSelect={true}
                />
              </div>
              <div className="allEventsPage__filtersActions">
                <button type="button" className="allEventsButton is-clear" onClick={this.onClearFilterClick}>
                  Clear all
                </button>
                <div>
                  <button type="button" className="allEventsButton" onClick={this.onTableFilterClick}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="allEventsButton allEventsButton--primary is-apply"
                    onClick={this.onApplyFilterClick}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
          {selectedItems.length > 0 && (
            <div className="allEventsPage__selection">
              <span>{selectedItems.length} selected</span>
              <div>
                {isCancelEventActionAvailable && (
                  <button className="is-danger" onClick={this.cancelEventModalOpen}>
                    Cancel event
                  </button>
                )}
                {isRestoreEventActionAvailable && <button onClick={this.uncancelEventModalOpen}>Restore events</button>}
                {isDeleteEventActionAvailable && (
                  <button className="is-danger" onClick={this.deleteEventModalOpen}>
                    Delete
                  </button>
                )}
                <button className="allEventsPage__selectionClear" onClick={this.onUnselectAllClick}>
                  Clear selection
                </button>
              </div>
            </div>
          )}
          {archiveNeedsCriteria ? (
            <section className="allEventsPage__archiveEmpty">
              <div className="allEventsPage__archiveEmptyIcon">⌕</div>
              <h2>Search the event archive</h2>
              <p>
                Set at least one filter to load archived events. This keeps the archive fast and avoids downloading the
                full event history.
              </p>
              <button
                type="button"
                className="allEventsButton allEventsButton--primary"
                onClick={this.onTableFilterClick}
              >
                Open filters
              </button>
            </section>
          ) : (
            <section className="allEventsPage__card">
              <div className="allEventsPage__scroll">
                <table>
                  <thead>
                    <tr>
                      <th>
                        <SelectAllCheckbox
                          compact
                          isChecked={
                            isSelectAllChecked || (items.length > 0 && items.every(item => selectedIds.has(item.id)))
                          }
                          totalCount={total}
                          currentPage={currentPage}
                          pageItemsCount={items.length}
                          selectedItems={selectedItems}
                          onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                          onSelectAllClick={this.onSelectAllClick}
                          onUnselectAllClick={this.onUnselectAllClick}
                        />
                      </th>
                      <th>Event</th>
                      {!hiddenColumns.has('date') && (
                        <th>
                          <button onClick={() => this.onTableSortClick('startTime')}>Date &amp; time</button>
                        </th>
                      )}
                      {!hiddenColumns.has('sport') && <th>Sport</th>}
                      {!hiddenColumns.has('ages') && <th>Ages</th>}
                      {!hiddenColumns.has('gender') && <th>Gender</th>}
                      {!hiddenColumns.has('venue') && <th>Venue</th>}
                      {!hiddenColumns.has('status') && <th>Status</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((eventItem, index) => (
                      <tr
                        key={eventItem.id}
                        className={selectedIds.has(eventItem.id) ? 'is-selected' : ''}
                        onClick={() => this.onOpenEventClick(index)}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIds.has(eventItem.id)}
                            onChange={() => this.onItemClick(index)}
                            onClick={clickEvent => clickEvent.stopPropagation()}
                          />
                        </td>
                        <td>
                          <div className="allEventsPage__event">
                            <i>
                              <svg viewBox="0 0 24 24">
                                <path d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z" />
                              </svg>
                            </i>
                            <div>
                              <strong>{getEventGeneratedName(eventItem, { user })}</strong>
                              <small>
                                {getEventType(eventItem)} · {getEventGender(eventItem)}
                              </small>
                            </div>
                          </div>
                        </td>
                        {!hiddenColumns.has('date') && (
                          <td>
                            <strong className="allEventsPage__date">{getEventStartTime(eventItem)}</strong>
                            <small className="allEventsPage__finish">to {getEventEndTime(eventItem)}</small>
                          </td>
                        )}
                        {!hiddenColumns.has('sport') && <td>{propz.get(eventItem, ['sport', 'name'], '—')}</td>}
                        {!hiddenColumns.has('ages') && (
                          <td>
                            {(eventItem.ages || []).length
                              ? getAgesGroupFormatted({ ...eventItem, ages: [...eventItem.ages] }, { user })
                              : 'All ages'}
                          </td>
                        )}
                        {!hiddenColumns.has('gender') && <td>{getEventGender(eventItem) || '—'}</td>}
                        {!hiddenColumns.has('venue') && <td>{getEventVenue(eventItem) || '—'}</td>}
                        {!hiddenColumns.has('status') && (
                          <td>
                            <span
                              className={`allEventsPage__status is-${String(eventItem.status || '').toLowerCase()}`}
                            >
                              {getEventStatus(eventItem)}
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
                    {!items.length && (
                      <tr>
                        <td
                          colSpan={optionalColumns.filter(([key]) => !hiddenColumns.has(key)).length + 2}
                          className="allEventsPage__empty"
                        >
                          <ListEmptyState
                            icon={faCalendarAlt}
                            title={isDataFiltered ? 'No events match your filters' : 'No current events'}
                            description={
                              isDataFiltered
                                ? 'Try changing or clearing the filters to see more events.'
                                : 'Upcoming fixtures, activities and club events will appear here.'
                            }
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          )}
          {!archiveNeedsCriteria && total > 0 && (
            <nav className="allEventsPage__pagination">
              <span>
                Page {currentPage} of {pageCount}
              </span>
              <button disabled={currentPage <= 1} onClick={() => this.setCurrentPageParams(currentPage - 1)}>
                Previous
              </button>
              {pageWindowStart > 1 && (
                <>
                  <button className="allEventsPage__page" onClick={() => this.setCurrentPageParams(1)}>
                    1
                  </button>
                  {pageWindowStart > 2 && <i>…</i>}
                </>
              )}
              {pageNumbers.map(page => (
                <button
                  key={page}
                  className={`allEventsPage__page ${page === currentPage ? 'is-active' : ''}`}
                  onClick={() => this.setCurrentPageParams(page)}
                >
                  {page}
                </button>
              ))}
              {pageWindowEnd < pageCount && (
                <>
                  {pageWindowEnd < pageCount - 1 && <i>…</i>}
                  <button className="allEventsPage__page" onClick={() => this.setCurrentPageParams(pageCount)}>
                    {pageCount}
                  </button>
                </>
              )}
              <button disabled={currentPage >= pageCount} onClick={() => this.setCurrentPageParams(currentPage + 1)}>
                Next
              </button>
            </nav>
          )}
        </section>
      </div>
    );
  }

  render() {
    const { user } = this.props;
    const {
      isErrorModalOpen,
      isCreateEventModalOpen,
      isEditEventDetailsModalOpen,
      isCreateEventJobModalOpen,
      isAttendanceLogModalOpen,
      selectedItems,
      isFixturesScheduleReportModalOpen,
      isFixtureParticipationByStudentsReportModalOpen,
      isFixtureResultsReportModalOpen,
      isDateFixturesReportModalOpen,
      isFixtureHistoryReportModalOpen,
      isFixtureStatisticsForPeriodReportModalOpen,
      isLoading
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isErrorModalOpen ||
      isCreateEventModalOpen ||
      isEditEventDetailsModalOpen ||
      isCreateEventJobModalOpen ||
      isAttendanceLogModalOpen ||
      isFixturesScheduleReportModalOpen ||
      isFixtureParticipationByStudentsReportModalOpen ||
      isFixtureResultsReportModalOpen ||
      isDateFixturesReportModalOpen ||
      isFixtureHistoryReportModalOpen ||
      isFixtureStatisticsForPeriodReportModalOpen
        ? 'allEventsScreen modal-open'
        : 'allEventsScreen';

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderEventJobForm()}
        {this.renderDeleteJobModal()}
        {this.renderCancelEventModal()}
        {this.renderDeleteEventModal()}
        {this.renderUncancelEventModal()}
        {this.renderReportsModal()}
        {this.renderAggregateEventParticipationReportFormModal()}
        {this.renderConfirmationDeleteEventModal()}
        {this.renderEventDetailsForm()}
        {this.renderSendingError()}
        <AttendanceLogModal
          user={user}
          eventId={selectedItems[0]?.id}
          isOpen={isAttendanceLogModalOpen}
          onClose={this.onCloseAttendanceLog}
        />
        {this.renderFixturesScheduleReportFormModal()}
        {this.renderFixtureParticipationByStudentsReportFormModal()}
        {this.renderFixtureResultsReportFormModal()}
        {this.renderDateFixturesReportFormModal()}
        {this.renderFixtureHistoryReportFormModal()}
        {this.renderFixtureStatisticsForPeriodReportFormModal()}
        {this.renderGrid()}
      </div>
    );
  }
}
